import React, { useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'
// import { Button } from 'react-bootstrap'
// import TaggedPerson from './TaggedPerson'
// import { MdModeEditOutline } from 'react-icons/md'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import SelectedMoviePersonUi from './SelectedMoviePersonUi'

export default function SelectedMoviesPersonData(props) {
  const {
    selectedMovieOrPersonData,
    editIndexes,
    handleChangeDescription,
    handleDelete,
    handleMoveItem,
    handleEdit,
    allTaggedPersons,
    selectedListType,
    sendTaggedPersons,
    // addOrRemoveTaggedPerson,
    editMode,
    setSelectedMovieOrPersonData,
    setvalueEdited,
  } = props
  const [requiredImageSize, setRequiredImageSize] = useState([])
  const getFormattedImage = posterUrl => {
    const cdnurl = AwsConfig.movieCdnUrl
    let posterImage = posterUrl
    if (posterImage && !posterImage.includes(cdnurl)) {
      posterImage = cdnurl + posterImage
    }

    return posterImage
  }

  const PushVideo = index => {
    youtubeUrl(index)
    setvalueEdited(true)
  }

  const uploadImage = async (e, index) => {
    const maxSize = 1024 * 1024 // 1MB
    const requiredImageSizeTemp = [...requiredImageSize]
      if (e.target.files[0].size > maxSize) {
        requiredImageSizeTemp[index] = true
        setRequiredImageSize(requiredImageSizeTemp)
        return
      }

      requiredImageSizeTemp[index] = false
      setRequiredImageSize(requiredImageSizeTemp)
    const randomId = await uuidv4()
    const { textPath } = AwsConfig
    const key = textPath + randomId + '.jpeg'
    const params = {
      key,
      mimeType: 'image/jpeg',
    }

    const preSignedURLObject = await MovieImagePresignedUrl(params)

    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)

    const signedURL = signedURLObject.data.url

    try {
      const formData = new FormData()

      Object.keys(signedURLObject.data.fields).forEach(key => {
        formData.append(key, signedURLObject.data.fields[key])
      })
      // Actual file has to be appended last.
      formData.append('file', e.target.files[0])

      await axios({
        method: 'post',
        url: signedURL,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      // const cdnurl = AwsConfig.movieCdnUrl

      const posterUrl = key

      const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
      selectedMovieOrPersonDataTemp[index].listItemImage = posterUrl
      setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    } catch (err) {
      console.warn(err, 'err')
    }
  }

  const removeImage = index => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    selectedMovieOrPersonDataTemp[index].listItemImage = ''
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    setvalueEdited(true)
  }

  const youtubeUrl = index => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]

    // selectedMovieOrPersonDataTemp[index].tempUrl = e.target.value
    if (selectedMovieOrPersonDataTemp[index].tempUrl !== '') {
      if (
        selectedMovieOrPersonDataTemp[index].tempUrl.includes('https://www.youtube.com/') === false
      ) {
        selectedMovieOrPersonDataTemp[index].youtubeEmbedLink = ''
      } else if (selectedMovieOrPersonDataTemp[index].tempUrl.includes('embed')) {
        const url = selectedMovieOrPersonDataTemp[index].tempUrl
        const videoId = url.split('embed/')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          // setEmbedVideoId()
          selectedMovieOrPersonDataTemp[
            index
          ].youtubeEmbedLink = `https://www.youtube.com/embed/${videoId.substring(
            0,
            ampersandPosition,
          )}`
        } else {
          // setEmbedVideoId(videoId ? videoId : '')
          selectedMovieOrPersonDataTemp[
            index
          ].youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`
        }
      } else {
        // EmbedVideoId of youtube
        const url = selectedMovieOrPersonDataTemp[index].tempUrl
        const videoId = url.split('v=')[1]
        const ampersandPosition = videoId.indexOf('&')
        // if (ampersandPosition > -1) {
        //   setEmbedVideoId(videoId.substring(0, ampersandPosition))
        // } else {
        //   setEmbedVideoId(videoId ? videoId : '')
        // }

        if (ampersandPosition > -1) {
          // setEmbedVideoId()
          selectedMovieOrPersonDataTemp[
            index
          ].youtubeEmbedLink = `https://www.youtube.com/embed/${videoId.substring(
            0,
            ampersandPosition,
          )}`
        } else {
          // setEmbedVideoId(videoId ? videoId : '')
          selectedMovieOrPersonDataTemp[
            index
          ].youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`
        }
      }
    }

    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    delete selectedMovieOrPersonDataTemp[index].tempUrl
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
  }

  const getURl = (e, index) => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    selectedMovieOrPersonDataTemp[index].tempUrl = e.target.value
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
  }

  const removeVideo = index => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    selectedMovieOrPersonDataTemp[index].tempUrl = ''
    selectedMovieOrPersonDataTemp[index].youtubeEmbedLink = ''
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    setvalueEdited(true)
  }

  const EditVideo = index => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    selectedMovieOrPersonDataTemp[index].tempUrl =
      selectedMovieOrPersonDataTemp[index].youtubeEmbedLink
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    delete selectedMovieOrPersonDataTemp[index].youtubeEmbedLink
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    setvalueEdited(true)
  }

  const changelistItemTitle = (e, index, lang) => {
    const selectedMovieOrPersonDataTemp = [...selectedMovieOrPersonData]
    selectedMovieOrPersonDataTemp[index][`listItemTitle_${lang}`] = e.target.value
    setSelectedMovieOrPersonData(selectedMovieOrPersonDataTemp)
    setvalueEdited(true)
  }

  return (
    <SelectedMoviePersonUi
      selectedMovieOrPersonData={selectedMovieOrPersonData}
      selectedListType={selectedListType}
      changelistItemTitle={changelistItemTitle}
      editIndexes={editIndexes}
      getFormattedImage={getFormattedImage}
      uploadImage={uploadImage}
      removeImage={removeImage}
      handleChangeDescription={handleChangeDescription}
      handleDelete={handleDelete}
      handleMoveItem={handleMoveItem}
      EditVideo={EditVideo}
      removeVideo={removeVideo}
      getURl={getURl}
      PushVideo={PushVideo}
      handleEdit={handleEdit}
      editMode={editMode}
      allTaggedPersons={allTaggedPersons}
      // addOrRemoveTaggedPerson={addOrRemoveTaggedPerson}
      sendTaggedPersons={sendTaggedPersons}
      setvalueEdited={setvalueEdited}
      requiredImageSize={requiredImageSize}
    />
  )
}
